












import { defineComponent, computed, useRoute } from '@nuxtjs/composition-api';
import TechnicalDetail from '~/components/molecules/Product/details/TechnicalDetail.vue';
import { useProductExtended } from '~/composables';
import { ProductDetail } from '~/types/product/attribute/ProductDetail';

export default defineComponent({
  name: 'TechnicalDetails',
  components: {
    TechnicalDetail,
  },
  setup() {
    const route = useRoute();
    const slug = computed(() => route.value.params.slug);

    const { masterProductLocalisedAttributes: attributesLocalized } = useProductExtended(slug.value);

    const technicalDetails = computed<ProductDetail[]>(() => attributesLocalized.value?.techdetails || []);

    return {
      technicalDetails,
    };
  },
});
